<template>
  <!-- 省エネレポート詳細（航路指定） -->
  <div class="fuel-consumption-detail fuel-consumption-detail-voyage">
    <vx-card class="p-0 m-0" :key="detailCardKey">
      <!-- ヘッダー -->
      <div class="header block sm:flex sm:items-center sm:justify-between mb-2">
        <!-- 左 -->
        <div class="vessel-name-text mr-4">
          <div class="font-semibold">{{ vesselName }}</div>
        </div>

        <!-- 右 -->
        <div class="header-right-area flex items-center justify-end no-print">
          <!-- 次の航路 -->
          <div
            class="menu-button"
            @click="clickNextVoyageButton()"
            v-show="!isLastIndex"
          >
            <div class="flex items-center">
              <feather-icon
                icon="ChevronLeftIcon"
                svgClasses="h-6 w-6"
                class="cursor-pointer"
              ></feather-icon>
              <span class="mx-2">{{ nextRouteText }}</span>
            </div>
          </div>

          <!-- 次の航路(非活性) -->
          <div class="menu-button__disabled" v-show="isLastIndex">
            <div class="flex items-center">
              <feather-icon
                icon="ChevronLeftIcon"
                svgClasses="h-6 w-6"
              ></feather-icon>
              <span class="mx-2">{{ nextRouteText }}</span>
            </div>
          </div>

          <div class="vertical-divider h-6 ml-2"></div>

          <!-- 前の航路 -->
          <div
            class="menu-button"
            @click="clickPrevVoyageButton()"
            v-show="!isFirstIndex"
          >
            <div class="flex items-center">
              <span class="mx-2">{{ prevRouteText }}</span>
              <feather-icon
                icon="ChevronRightIcon"
                svgClasses="h-6 w-6"
                class="cursor-pointer"
              ></feather-icon>
            </div>
          </div>

          <!-- 前の航路(非活性) -->
          <div class="menu-button__disabled" v-show="isFirstIndex">
            <div class="flex items-center">
              <span class="mx-2">{{ prevRouteText }}</span>
              <feather-icon
                icon="ChevronRightIcon"
                svgClasses="h-6 w-6"
              ></feather-icon>
            </div>
          </div>

          <!-- メニュー -->
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer lg:hidden"
            :color="AISEA_COLOR.GRAY"
          >
            <div class="menu-button">
              <feather-icon
                icon="MoreHorizontalIcon"
                svgClasses="h-6 w-6"
              ></feather-icon>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item class="w-48 p-1">
                <div @click="clickPeriodButton()">
                  <div class="flex items-center">
                    <img :src="periodButtonIconSrc" class="w-6 h-6" />
                    <span class="ml-2">月・年次の解析</span>
                  </div>
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item class="w-48 p-1">
                <div @click="clickExportButton()">
                  <div class="flex items-center">
                    <img :src="exportButtonIconSrc" class="w-6 h-6" />
                    <span class="ml-2">PDF印刷</span>
                  </div>
                </div>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <div class="hidden lg:flex lg:items-center">
            <div class="menu-button" @click="clickPeriodButton()">
              <div class="flex items-center">
                <img :src="periodButtonIconSrc" />
                <span class="ml-2">月・年次の解析</span>
              </div>
            </div>
            <div class="menu-button" @click="clickExportButton()">
              <div class="flex items-center">
                <img :src="exportButtonIconSrc" />
                <span class="ml-2">PDF印刷</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-area xl:flex justify-between">
        <!-- 左上 -->
        <div class="content-left-area w-full xl:w-5/12 xl:pr-4 print-break">
          <div class="period-area mb-4">
            <p class="mb-4">
              <span> 出発港：</span>
              <span class="font-semibold">{{ startPortName }} </span>
              <span class="ml-2"> 出発時間</span>
              <span class="font-semibold">： {{ startPortDate }} </span>
            </p>
            <p>
              <span> 目的港：</span>
              <span class="font-semibold">{{ goalPortName }} </span>
              <span class="ml-2"> 到着時間：</span>
              <span class="font-semibold"> {{ goalPortDate }} </span>
            </p>
          </div>

          <!-- カードコンポーネント群 -->
          <panel-card-list class="mb-4 xl:mb-0 print-break" />
        </div>
        <!-- 右上 -->
        <div
          class="content-right-area w-full xl:w-7/12 xl:content-between print-break"
        >
          <div class="map-view">
            <route-map ref="VesselLiveMap" :showMap="showMap"></route-map>
          </div>
          <div class="h-2/6">
            <map-info-table></map-info-table>
          </div>
        </div>
      </div>

      <div class="tab-container mt-4 flex items-start justify-between no-print">
        <vs-tabs
          :color="AISEA_COLOR.DARK_BLUE"
          class="no-print"
          v-model="selectedTab"
        >
          <vs-tab
            class="tabs-shadow-none"
            v-for="item in tabOptions"
            :key="item.id"
            :label="item.label"
          ></vs-tab>
          <chart-fuel-consumption
            v-show="selectedTab === 0"
          ></chart-fuel-consumption>
          <multi-sensor
            v-show="selectedTab === 1"
            ref="multiSensor"
          ></multi-sensor>
        </vs-tabs>
      </div>
      <div class="print">
        <section class="print-break ">
          <h1>燃料消費量</h1>
          <chart-fuel-consumption
            ref="chartFuelConsumption"
          ></chart-fuel-consumption>
        </section>
        <section class="print-break ">
          <h1>センサー</h1>
          <multi-sensor></multi-sensor>
        </section>
      </div>
    </vx-card>
    <fuel-consumption-period-dialog ref="FuelConsumptionPeriodDialog" />
  </div>
</template>

<script>
import PanelCardList from "./components/PanelCardList.vue";
import MapInfoTable from "./components/MapInfoTable";
import { createNamespacedHelpers } from "vuex";
const {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} = createNamespacedHelpers("fuelConsumption");
import { RouteMap, ChartFuelConsumption, MultiSensor } from "./components";
import { ColorMixin } from "@/mixins";
import FuelConsumptionPeriodDialog from "../../fuel-consumption-vessel-list/components/FuelConsumptionPeriodDialog.vue";

export default {
  components: {
    PanelCardList,
    MapInfoTable,
    RouteMap,
    FuelConsumptionPeriodDialog,
    ChartFuelConsumption,
    MultiSensor,
  },
  mixins: [ColorMixin],
  data() {
    return {
      periodButtonIconSrc: require("@/assets/images/fuel-consumption/icon/calendar.svg"),
      exportButtonIconSrc: require("@/assets/images/fuel-consumption/icon/document.svg"),
      prevRouteText: "前の航路",
      nextRouteText: "次の航路",
      showMap: true,
      detailCardKey: 1,
      selectedTab: 0,
      tabOptions: [
        {
          label: "燃料消費量",
        },
        {
          label: "圧力/温度",
        },
      ],
    };
  },

  watch: {
    async voyageId(val) {
      this.RESET_DETAIL_DATA();
      await this.reloadCard();
      await this.init();
    },
  },

  computed: {
    ...mapState(["vessels"]),
    ...mapGetters([
      "getStartPort",
      "getGoalPort",
      "getUsualRoute",
      "getRecomendedRoute",
      "getActualRoute",
      "getRouteAgreementRate",
      "getMapCenterPosition",
      "getPrevVoyageId",
      "getNextVoyageId",
      "getIsFirstIndex",
      "getIsLastIndex",
      "getStartPortDate",
      "getGoalPortDate",
      "getVessel",
      "getVoyageTimeRange",
    ]),
    vessel() {
      return this.getVessel(this.vesselId);
    },
    vesselName() {
      if (!this.vessel) return "";
      return this.vessel.name;
    },
    startPortName() {
      if (!this.getStartPort || !this.getStartPort.name) return "-";
      return this.getStartPort.name;
    },
    goalPortName() {
      if (!this.getGoalPort || !this.getGoalPort.name) return "-";
      return this.getGoalPort.name;
    },
    startPortDate() {
      return this.getStartPortDate;
    },
    goalPortDate() {
      return this.getGoalPortDate;
    },
    vesselId() {
      return this.$route.params.vesselId;
    },
    voyageId() {
      return this.$route.params.voyageId;
    },

    isFirstIndex() {
      return this.getIsFirstIndex(this.voyageId);
    },

    isLastIndex() {
      return this.getIsLastIndex(this.voyageId);
    },
  },

  methods: {
    ...mapActions([
      "fetchVoyageList",
      "fetchVoyageRecords",
      "fetchAllVessels",
      "fetchSensorData",
    ]),
    ...mapMutations(["RESET_DETAIL_DATA"]),

    clickPrevVoyageButton() {
      const prevVoyageId = this.getPrevVoyageId(this.voyageId);

      this.$router.push({
        name: this.$route.name,
        params: { vesselId: this.vesselId, voyageId: prevVoyageId },
      });
    },
    clickNextVoyageButton() {
      const nextVoyageId = this.getNextVoyageId(this.voyageId);

      this.$router.push({
        name: this.$route.name,
        params: { vesselId: this.vesselId, voyageId: nextVoyageId },
      });
    },
    clickPeriodButton() {
      this.$refs.FuelConsumptionPeriodDialog.show(this.vesselId);
    },
    clickExportButton() {
      this.$refs.chartFuelConsumption.print();
      window.print();
    },
    setShowMap(showMap) {
      this.showMap = showMap;
    },
    async fetch() {
      try {
        const payload = {
          vesselId: this.$route.params.vesselId,
          historyId: this.$route.params.voyageId,
        };
        await this.fetchVoyageRecords(payload);
        await this.fetchSensorData({
          vessel: this.getVessel(this.$route.params.vesselId),
          timeRange: this.getVoyageTimeRange,
        });
        this.setShowMap(true);
      } catch (error) {
        this.$vs.notify({
          title: "航海記録の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
        this.setShowMap(false);
      }
    },
    async init() {
      try {
        this.$vs.loading();
        if (this.vessels.length === 0) {
          await this.fetchAllVessels();
        }
        await this.fetch();
        await this.$refs.VesselLiveMap.initMap();
        this.$vs.loading.close();
      } catch (error) {
        this.setShowMap(false);
        this.$vs.loading.close();
      }
    },
    reloadCard() {
      //コンポーネント再描写
      this.detailCardKey = this.detailCardKey ? 0 : 1;
    },
  },

  async created() {
    this.RESET_DETAIL_DATA();
  },

  async mounted() {
    await this.init();
    await this.fetchVoyageList({ vesselId: this.vesselId, limit: 9999 });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "src/assets/scss/aisea/fuel-consumption";

.fuel-consumption-detail-voyage {
  font-family: $aisea-font-family;

  .line-vs-tabs {
    box-shadow: none !important;
    background: $aisea-dark-gray !important;
  }

  .vessel-name-text {
    font-size: 24px;
  }

  .menu-button {
    @extend .button;
    width: fit-content;
    height: fit-content;
    padding: 6px;
    white-space: nowrap;

    &__disabled {
      @extend .menu-button;
      color: $aisea-mouse-gray;
      cursor: default;

      &:hover {
        background-color: $aisea-pure-white;
      }
    }
  }
}

.tab-container {
  height: 600px;
  padding: 10px;
  border: 1px solid $aisea-mouse-gray;
  border-radius: 5px;
}

.print {
  display: none;
  page-break-after: always;
}

.print-break {
  break-after: page;
}

@media print {
  .print {
    display: block;
  }
  .no-print {
    display: none;
  }
}
</style>
